import { render } from "./UiBadgeDisplay.vue?vue&type=template&id=de931ada&scoped=true"
import script from "./UiBadgeDisplay.vue?vue&type=script&lang=js"
export * from "./UiBadgeDisplay.vue?vue&type=script&lang=js"

import "./UiBadgeDisplay.vue?vue&type=style&index=0&id=de931ada&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de931ada"]])

export default __exports__